import React, { PropsWithChildren } from "react";
import { useTrackActivity } from "@/shared/hooks/useTrackActivity";

export const ActivityTrackingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // This hook will track user activity automatically
  useTrackActivity();
  return <>{children}</>;
};
